import { api } from "src/common/utils/api";

export function getOriginalFileName(name: string): string {
	const parts = name.split(/[/\\]/);
	return parts[parts.length - 1];
}

interface SaveFilesOptions {
	org: string;
	mod: string;
	patientId: string;
	files: File[];
}

export function saveFiles({
	org,
	mod,
	patientId,
	files
}: SaveFilesOptions): Promise<string[]> {
	return Promise.all(
		files.map(file => saveFile({ org, mod, patientId, file }))
	);
}

interface SaveFileOptions {
	org: string;
	mod: string;
	patientId: string;
	file: File;
}

export async function saveFile({
	org,
	mod,
	patientId,
	file
}: SaveFileOptions): Promise<string> {
	const data = await mapFileToBase64(file);
	const { data: fileId } = await api.post<string>(
		`/files/base64/${file.name}?organization=${org}&module=${mod}&patient=${patientId}`,
		data
	);
	return fileId;
}

export function mapFileToBase64(file: File): Promise<string> {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onload = event => {
			const { target } = event;
			if (target === null) {
				return resolve("");
			}
			const { result } = target;
			if (typeof result !== "string") {
				return resolve("");
			}
			const matches = result.match(/base64,(.*)/);
			if (matches === null) {
				return resolve("");
			}
			resolve(matches[1]);
		};
		reader.onerror = error => {
			reject(error);
		};
	});
}
